import { IActionFn, IOptionRecord, IPageData } from '@/store/types';
import { $http } from '@/axios';
import { IModuleState } from './types';
import store from '@/store';

// 查询当前用户的小组件列表
export const queryWidgetList: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setWidgetList', { ...state.widgetList, loading: true });
    const res = await $http.post('/v1/system/user/mywidgets', payload);
    commit('setWidgetList', { data: res });
  } catch (e) {
    commit('setWidgetList', { data: [] });
  }
};

// 查询客户端使用时长统计
export const queryClientUsageStats: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setClientUsageStats', { ...state.clientUsageStats, loading: true });
    const res = await $http.post('/v1/data/stat/clientusage', payload);
    commit('setClientUsageStats', { data: res });
  } catch (e) {
    commit('setClientUsageStats', { data: [] });
  }
};

// 查询客户端使用最多的10人列表
export const queryClientUsageList: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setClientUsageList', { ...state.clientUsageList, loading: true });
    const postUrl = '/v1/data/stat/clientusage/list';
    // 按登录时长统计
    const fetchByTime: Promise<any[]> = $http.post(postUrl, payload);
    // 按登录次数统计
    const fetchByCount: Promise<any[]> = $http.post(postUrl, { ...payload, type: 2 });
    const [res1, res2] = await Promise.all([fetchByTime, fetchByCount]);
    const list1 =  (res1 || []).map((item) => ({ ...item, type: 1 }));
    const list2 =  (res2 || []).map((item) => ({ ...item, type: 2 }));
    commit('setClientUsageList', { data: [...list1, ...list2] });
  } catch (e) {
    commit('setClientUsageList', { data: [] });
  }
};

// 查询客户端出错上报统计
export const queryClientCrashStats: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setClientCrashStats', { ...state.clientCrashStats, loading: true });
    const res = await $http.post('/v1/data/stat/crashreport', payload);
    commit('setClientCrashStats', { data: res });
  } catch (e) {
    commit('setClientCrashStats', { data: [] });
  }
};

// 查询客户端崩溃最近发送报告的10人
export const queryClientCrashList: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setClientCrashList', { ...state.clientCrashList, loading: true });
    const params = { pageNum: 1, pageSize: 10, ...payload };
    const res: IPageData = await $http.post('/v1/system/crashreport/pagelist', params);
    commit('setClientCrashList', { data: res.list || [] });
  } catch (e) {
    commit('setClientCrashList', { data: [] });
  }
};

// 查询文件下载总量统计信息
export const queryOssDownloadStats: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOssDownloadStats', { ...state.ossDownloadStats, loading: true });
    const res = await $http.post('/v1/data/stat/ossusage', payload);
    commit('setOssDownloadStats', { data: res });
  } catch (e) {
    commit('setOssDownloadStats', { data: [] });
  }
};

// 查询文件下载量最大的10人列表
export const queryOssDownloadList: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOssDownloadList', { ...state.ossDownloadList, loading: true });
    const res = await $http.post('/v1/data/stat/ossusage/list', payload);
    commit('setOssDownloadList', { data: res });
  } catch (e) {
    commit('setOssDownloadList', { data: [] });
  }
};

// 查询用户异常登录统计
export const queryLoginThreshStats: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setLoginThreshStats', { ...state.loginThreshStats, loading: true });
    const res = await $http.post('/v1/data/stat/loginthreshold', payload);
    commit('setLoginThreshStats', { data: res });
  } catch (e) {
    commit('setLoginThreshStats', { data: [] });
  }
};

// 查询用户异常登录统计详细列表
export const queryLoginThreshList: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setLoginThreshList', { ...state.loginThreshList, loading: true });
    const postUrl = '/v1/data/stat/loginthreshold/list';
    // 按组织统计
    const fetchByOrg: Promise<any[]> = $http.post(postUrl, payload);
    // 按用户统计
    const fetchByUser: Promise<any[]> = $http.post(postUrl, { ...payload, isUserAgg: true });
    const [res1, res2] = await Promise.all([fetchByOrg, fetchByUser]);
    const list1 =  (res1 || []).map((item) => ({ ...item, type: 1 }));
    const list2 =  (res2 || []).map((item) => ({ ...item, type: 2 }));
    commit('setLoginThreshList', { data: [...list1, ...list2] });
  } catch (e) {
    commit('setLoginThreshList', { data: [] });
  }
};

// 查询专案和样板间新增数量统计
export const queryDpgIncrementStats: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDpgIncrementStats', { ...state.dpgIncrementStats, loading: true });
    const res = await $http.post('/v1/data/stat/designcount', payload);
    commit('setDpgIncrementStats', { data: res });
  } catch (e) {
    commit('setDpgIncrementStats', { data: [] });
  }
};

// 查询新增专案/样板间数量详细列表
export const queryDpgIncrementList: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDpgIncrementList', { ...state.dpgIncrementList, loading: true });
    const postUrl = '/v1/data/stat/designcount/list';
    // 按专案组统计
    const fetchByOrg: Promise<any[]> = $http.post(postUrl, { ...payload, isDesign: true });
    // 按样板间统计
    const fetchByUser: Promise<any[]> = $http.post(postUrl, { ...payload, isDesign: false });
    const [res1, res2] = await Promise.all([fetchByOrg, fetchByUser]);
    const list1 =  (res1 || []).map((item) => ({ ...item, type: 1 }));
    const list2 =  (res2 || []).map((item) => ({ ...item, type: 2 }));
    commit('setDpgIncrementList', { data: [...list1, ...list2] });
  } catch (e) {
    commit('setDpgIncrementList', { data: [] });
  }
};

// 保存首页布局(删除, 新增, 保存配置, 多合一)
export const saveWidgetConfig: IActionFn<IModuleState> = async ({ commit }, payload) => {
  const { delIds, configs, userId } = payload;
  const requests: Array<Promise<void>> = [];
  commit('setSaving', true);

  // 删除小组件
  if (delIds?.length) {
    requests.push($http.post('/v1/system/user/deletewidget', { ids: delIds }));
  }

  // 新增或保存小组件
  if (configs?.length) {
    requests.push($http.post('/v1/system/user/editwidget', { configs, userId }));
  }

  try {
    await Promise.all(requests);
  } finally {
    commit('setSaving', false);
  }
};

// 查询小组件对应的编码字典(预留)
export const queryWidgetOptions: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setWidgetOptions', { ...state.widgetOptions, loading: true });
    const res: IOptionRecord[] = await $http.get('/common/chooseoptions/WidgetSpecies');
    commit('setWidgetOptions', { data: res });
  } catch (e) {
    commit('setWidgetOptions', { data: [] });
  }
};

// 查询组织统计信息(暂时没用，预留)
export const queryOrgStats: IActionFn<IModuleState> = async () => {
  await $http.get('/baseinfo/authstatistics');
};
